import { gql } from '@lcs/shared/api';

export const getAccountDetail = gql`
   query GetAccountDetail($id: UInt!) {
      account(id: $id) {
         accountId
         name
         shortName
         activeStartDate
         activeEndDate
         isSuspended
         isInternationalDialingEnabled
         isInternationalDialingSuspended
         isCallRecordingFeatureEnabled
         isRecordInternalCalls
         isRecordInboundCalls
         isRecordOutboundCalls
         isMailboxMessageTranscriptionEnabled
         logLevelChangedByUser {
            username
         }
         reasonLogLevelChanged
         presenceEnabled
         fileStoreId
         queueManagementStrategyTypeId
         isAgentCanAssign
         hasPresenceCredentials
         presenceUser
         holdMusicPrompt {
            promptId
            name
         }
         operatorExtension {
            extensionId
            name
            number
         }
         lcsAccountNumber
         isResidential
         callRetentionPolicyTypeId
         nameDirectoryPreferenceId
         pstnLineLimit
         timeZoneId
         createDate
         createUser {
            userId
            name
         }
         updateDate
         updateUser {
            userId
            name
         }
         extensionsConnection {
            items {
               extensionId
               name
               number
               type
               isArchived
            }
         }
         extensionGroupsConnection {
            items {
               extensionGroupId
               name
               description
            }
         }
         note {
            noteId
            accountId
            notes
            isSystemNote
         }
         isOtrEnabled
         defaultAreaCode
         logLevelId
         faxFileTypeId
         isMissedCallsShown
         reasonLogLevelChanged
         logLevelChanged
         isFmFmEnabled
         isLcsInternal
         outboundRecordingNotificationEnabled
         schedule {
            scheduleId
            name
         }
      }
   }
`;
